<template>
	<div class="twice-box">
		<div class="title-box">
			<div @click="freshIndex">
				<img style="margin-top:10px;cursor: pointer" src="@/assets/knowlogo.png" alt="">
			</div>
			<div class="search-box">
				<div>
					<input type="text" placeholder="请输入产品型号" v-model="keywords"  @keyup.enter="search">
					<!--<div class="hot-search">热门搜索：VPL-GTZ1       YAX-720       Heco Ascada 300 BTX</div>-->
				</div>
				<div class="search-img">
					<button style="outline:none;" v-loading.fullscreen.lock="fullscreenLoading"  @click="search"><img src="@/assets/ss.png" alt="">搜索</button>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'App',
		data (){
			return {
				keywords:'',
				fullscreenLoading: false
			}
		},
		methods:{
			search(){
				this.$router.push({ path:'/',query: { kw: this.keywords}});
					this.fullscreenLoading = true;
					setTimeout(() => {
					this.fullscreenLoading = false;
					}, 1000);
			},
			freshIndex () {
				location.reload()
			}
		}

	}
</script>

<style>
.el-loading-spinner .path{
	stroke: #f9be04
}
	.twice-box{
		box-sizing: border-box;
		width: 1200px;
		margin: auto;
	}
	.title-box{
		display: flex;
		line-height: 61px;
	}
	.search-box{
		display: flex;
		margin-left: 77px;
	}
	.search-box input{
		background: #f5f9ff;
		height: 36px;
		width: 560px;
		border: none;
		box-sizing: border-box;
		padding-left: 10px;
	}
	.search-box input:focus{
		outline: none;
		border: 1px solid #f9be04;	
	}
	.search-box button{
		background: #F9BE04;
		color: #363636;
		width: 139px;
		height: 36px;
		border:none;
		align-items: center;
		cursor: pointer;
	}
	.search-img{
		position: relative;
	}
	.search-img img{
		position: absolute;
		left: 30px;
		top:25px
	}
	.hot-search{
		font-size: 12px;
		color: #6B6A6A;
		line-height: 17px;
	}
</style>



// WEBPACK FOOTER //
// src/components/knowshop/TwiceTitle.vue